import { useMemo } from "react";
import { LocalizationText } from "@/app/index";
import { Flex, Spin } from "@/base/components/index";
import { ModalForm } from "@/composites/modal-form/components/modal-form";
import { ModalTrackingViewContent } from "./modal-tracking-view-content";
import { useContextModalTrackingView } from "../context/modal-tracking-view-context";
import { useModalTrackingViewStyles } from "./modal-tracking-view.styles";

export const ModalTrackingView = () => {
  const { styles } = useModalTrackingViewStyles();
  const { isOpenModal, closeModal, loadingData } =
    useContextModalTrackingView();

  const widthConfig = useMemo(
    () => ({
      xs: "90%",
      sm: "90%",
      md: "90%",
      lg: "70%",
      xl: "70%",
      xxl: "60%",
    }),
    [],
  );

  return (
    <ModalForm
      footer={[]}
      width={widthConfig}
      open={isOpenModal}
      onCancel={closeModal}
      className={styles.modal}
      title={<LocalizationText value="modal.tracking.view.title" />}
    >
      {loadingData && (
        <Flex justify="center" align="center" className={styles.loader}>
          <Spin size="large" />
        </Flex>
      )}
      {!loadingData && <ModalTrackingViewContent />}
    </ModalForm>
  );
};
